export default "__VITE_ASSET__3e8be613__"